import React from 'react';
import { Link } from 'react-router-dom';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import property1 from '../../../../images/property/1.jpg';

const VerificationListView = ({ 
    propertyVerifyListRows, 
    loading, 
    isPending, 
    isCompleted, 
    handleStatusChange, 
    viewDocument, 
    getStatusColor,
    onSort,
    sortField,
    sortDirection
}) => {
    if (loading) {
        return (
            <div className="table-responsive">
                <table className="table table-responsive-md">
                    <thead>
                        <tr>
                            <th style={{ width: '80px' }}>
                                <Skeleton height={20} />
                            </th>
                            <th>
                                <Skeleton height={20} />
                            </th>
                            <th>
                                <Skeleton height={20} />
                            </th>
                            <th>
                                <Skeleton height={20} />
                            </th>
                            <th>
                                <Skeleton height={20} />
                            </th>
                            <th>
                                <Skeleton height={20} />
                            </th>
                            <th>
                                <Skeleton height={20} />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.from({ length: 6 }).map((_, idx) => (
                            <tr key={idx}>
                                <td><Skeleton height={40} /></td>
                                <td><Skeleton height={20} /></td>
                                <td><Skeleton height={20} /></td>
                                <td><Skeleton height={20} /></td>
                                <td><Skeleton height={20} /></td>
                                <td><Skeleton height={20} /></td>
                                <td><Skeleton height={30} /></td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    return (
        <div className="table-responsive">
            <table className="table table-responsive-md">
                <thead>
                    <tr>
                        <th style={{ width: '80px' }}>Image</th>
                        <th>Property</th>
                        <th>Customer</th>
                        <th>Contact</th>
                        <th>Location</th>
                        <th 
                            style={{ cursor: 'pointer' }}
                            onClick={() => onSort && onSort('createdAt')}
                            className="user-select-none"
                        >
                            Created
                            {onSort && (
                                <i 
                                    className={`fa ${
                                        sortField === 'createdAt' 
                                            ? sortDirection === 'desc' 
                                                ? 'fa-sort-down' 
                                                : 'fa-sort-up'
                                            : 'fa-sort'
                                    } ms-1`}
                                />
                            )}
                        </th>
                        {isCompleted && <th>Status</th>}
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {propertyVerifyListRows.map((item) => (
                        <tr key={item._id}>
                            <td>
                                <Link to={`/property-details/${item.propertyId._id}`}>
                                    <img 
                                        src={item.propertyId?.imageUrls?.[0] || property1} 
                                        alt="Property" 
                                        style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: 8 }}
                                        onError={(e) => {
                                            e.target.onerror = null; 
                                            e.target.src = property1; 
                                        }}
                                    />
                                </Link>
                            </td>
                            <td>
                                <div>
                                    <h6 className="mb-1">
                                        <Link 
                                            to={`/property-details/${item.propertyId._id}`}
                                            className="text-decoration-none"
                                        >
                                            {item.propertyId?.title?.length > 30 
                                                ? item.propertyId.title.substring(0, 30) + '...' 
                                                : item.propertyId?.title}
                                        </Link>
                                    </h6>
                                    <p className="mb-0 fs-12 text-muted">
                                        {item.propertyId?.description?.length > 40 
                                            ? item.propertyId.description.substring(0, 40) + '...' 
                                            : item.propertyId?.description}
                                    </p>
                                </div>
                            </td>
                            <td>
                                <div>
                                    <span className="fw-bold">{item?.userId?.name}</span>
                                    <br />
                                    <span className="text-muted fs-12">{item?.userId?.email}</span>
                                </div>
                            </td>
                            <td>
                                <span>{item?.userId?.phone}</span>
                            </td>
                            <td>
                                <span 
                                    title={item.propertyId?.address}
                                    className="text-muted"
                                >
                                    {item.propertyId?.address?.length > 30 
                                        ? item.propertyId.address.substring(0, 30) + '...' 
                                        : item.propertyId?.address}
                                </span>
                            </td>
                            <td>
                                <div>
                                    <span className="fw-bold">{new Date(item.createdAt).toLocaleDateString()}</span>
                                    <br />
                                    <span className="text-muted fs-12">{new Date(item.createdAt).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</span>
                                </div>
                            </td>
                            {isCompleted && (
                                <td>
                                    <span className={`badge badge-${getStatusColor(item.status)}`}>
                                        {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                                    </span>
                                </td>
                            )}
                            <td>
                                <div className="d-flex gap-1">
                                    {isPending && (
                                        <button 
                                            className="btn btn-danger btn-xs" 
                                            onClick={() => handleStatusChange(item._id, 'pickedup')}
                                            title="Pick Up"
                                        >
                                            Pick Up
                                        </button>
                                    )}
                                    {!isPending && (
                                        <button 
                                            className="btn btn-primary btn-xs" 
                                            onClick={() => viewDocument(item)}
                                            title="View Documents"
                                        >
                                            Documents
                                        </button>
                                    )}
                                    {(!isPending && !isCompleted) && (
                                        <button 
                                            className="btn btn-success btn-xs" 
                                            onClick={() => handleStatusChange(item._id, 'verified')}
                                            title="Mark as Verified"
                                        >
                                            Verified
                                        </button>
                                    )}
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default VerificationListView;